import { z } from 'zod';
import { toolFindChartsArgsSchema, toolFindDashboardsArgsSchema, toolFindExploresArgsSchema, toolFindFieldsArgsSchema, toolTableVizArgsSchema, toolTimeSeriesArgsSchema, toolVerticalBarArgsSchema, } from './tools';
export * from './customMetrics';
export * from './filters';
export * from './tools';
export * from './visualizations';
export const AgentToolCallArgsSchema = z.discriminatedUnion('type', [
    toolFindChartsArgsSchema,
    toolFindDashboardsArgsSchema,
    toolFindFieldsArgsSchema,
    toolVerticalBarArgsSchema,
    toolTableVizArgsSchema,
    toolTimeSeriesArgsSchema,
    toolFindExploresArgsSchema,
]);
//# sourceMappingURL=index.js.map